module.exports = __webpack_public_path__ + "img/8.f0f34814.jpg";